import React from "react"

import styles from "./PreviewModal.module.css"
import closeBtn from "../../assets/mobileClose.svg"

function PreviewModal({ setPreviewOpen, count, organization, inquiryPhone, email, send, setOrganization, setInquiryPhone, onSend }) {
	const closePreview = () => {
		setPreviewOpen(false)
	}

	let isSending = false

	return (
		<>
			<div className={styles.modalWrap}>
				<div className={styles.previewModal}>
					<div className={styles.modalHeader}>
						<h2>인증코드 발송</h2>
						<button type="button" onClick={closePreview}>
							<img src={closeBtn} alt="팝업 닫기" />
						</button>
					</div>
					<div className={styles.contentWrap}>
						<div className={styles.modalLt}>
							<h3>
								총 <span>{count}</span>건에 대하여 <br />
								다음의 정보로 인증코드를 발송합니다.
							</h3>
							<form>
								<div className={`${styles.formWrap} ${styles.required}`}>
									<div className={styles.formItem}>
										<div className={styles.formHead}>
											<span className={styles.formName}>발급기관 *</span>
										</div>
									</div>
									<div className={styles.formItem}>
										<div className={styles.formBody}>
											<span>
												<input type="text" name="name" required  value={organization} onChange={e => setOrganization(e.target.value)}/>
											</span>
										</div>
									</div>
								</div>
								<div className={`${styles.formWrap} ${styles.required}`}>
									<div className={styles.formItem}>
										<div className={styles.formHead}>
											<span className={styles.formName}>문의처 *</span>
										</div>
									</div>
									<div className={styles.formItem}>
										<div className={styles.formBody}>
											<span>
												<input type="tel" name="tel" required value={inquiryPhone} onChange={e => setInquiryPhone(e.target.value)}/>
											</span>
										</div>
									</div>
								</div>
								<div className={styles.formWrap}>
									<div className={styles.formItem}>
										<div className={styles.formHead}>
											<span className={styles.formName}>발신 이메일</span>
										</div>
									</div>
									<div className={styles.formItem}>
										<div className={styles.formBody}>
											<span>
												<input type="email" name="email" defaultValue={email} disabled />
											</span>
										</div>
									</div>
								</div>
								<div className={styles.formWrap}>
									<div className={styles.formItem}>
										<div className={styles.formHead}>
											<span className={styles.formName}>발신 번호</span>
										</div>
									</div>
									<div className={styles.formItem}>
										<div className={styles.formBody}>
											<span>
												<input type="tel" name="send" defaultValue={send}  disabled />
											</span>
										</div>
									</div>
								</div>
							</form>
							<span className={styles.info}>발급기관 정보는 마이페이지에서 설정하실 수 있습니다.</span>
						</div>
						<div className={styles.modalRt}>
							<div className={styles.preview}>
								<h4>안내</h4>
								<div className={styles.message}>
									{/*&#91;{organization} 심리검사 인증코드안내&#93; <br />*/}
									{/*<br />*/}
									안녕하세요. <br />
									[PTS 심리유형탐색 도구] 인증코드를 발송해드립니다. <br />
									<br />
									아래 [심리검사 시작]을 클릭하고,<br />
									이름 / 인증코드 [XXXX-XXXX-XXXX-XXXX]입력 후 검사를 실시해주세요. <br />
									<br />
									또는 도메인주소에 접속하여 실시해주세요.<br />
									<br />
									발급기관 : {organization} <br />
									문의처 : {inquiryPhone} <br /><br />
									심리검사 시작 주소: https://hcpts.net/start-test<br />
								</div>
								{/*<button type="button">검사하기</button>*/}
							</div>
							<span className={styles.info}>* 미리보기 화면입니다.</span>
						</div>
					</div>
					<div className={styles.btnWrap}>
						<button type="submit" onClick={() => {
							if (isSending) return
							isSending = true
							onSend()
							setTimeout(() => {
								isSending = false
							}, 5000)
						}}>발송하기</button>
						<button type="button" onClick={closePreview}>
							취소
						</button>
					</div>
				</div>
			</div>
		</>
	)
}

export default PreviewModal
